import React from "react";
import "./AdvanceSecurity.scss";
import {
  PhoneOutlined,
  PlusOutlined,
  MailOutlined,
} from "@ant-design/icons";
import {ReactComponent as Duo} from "@assets/icons/duo.svg";
import { Col, Collapse, Space } from "antd";
import { useUser } from "contexts/UserContext";
import SearchSetting from "@components/SearchSetting/SearchSetting";
const AdvanceSecurity: React.FC = () => {
  const text = `
  lorem ipsum
`;
  const { userProfile } = useUser();

  return (
    <div className="AdvanceSecurity">
      <SearchSetting />
      <div className="title">Advance Security</div>

      <Col>
        <div className="form-group">
          <div className="label">Two-factor Authentication</div>
          <Space className="space" direction="vertical">
            <Collapse
              collapsible="header"
              expandIconPosition="right"
              items={[
                {
                  key: "1",
                  label: (
                    <span className="collapse-header">
                      <Duo /> Duo Mobile
                    </span>
                  ),
                  children: <p>{text}</p>,
                },
              ]}
            />
            <Collapse
              collapsible="header"
              expandIconPosition="right"
              items={[
                {
                  key: "2",
                  label: (
                    <span className="collapse-header">
                      <PlusOutlined /> Additional Authenticator
                    </span>
                  ),
                  children: <p>{text}</p>,
                },
              ]}
            />
          </Space>
        </div>

        <div className="form-group">
          <div className="label">Back-ups</div>
          <Space className="space" direction="vertical">
            <Collapse
              collapsible="header"
              expandIconPosition="right"
              items={[
                {
                  key: "1",
                  label: (
                    <span className="collapse-header">
                      <MailOutlined /> {userProfile?.email || "Email"}
                    </span>
                  ),
                  children: <p>{text}</p>,
                },
              ]}
            />
            <Collapse
              collapsible="header"
              expandIconPosition="right"
              items={[
                {
                  key: "2",
                  label: (
                    <span className="collapse-header">
                      <PhoneOutlined /> {userProfile?.phone || "Phone Number"}
                    </span>
                  ),
                  children: <p>{text}</p>,
                },
              ]}
            />
            <Collapse
              collapsible="header"
              expandIconPosition="right"
              items={[
                {
                  key: "3",
                  label: (
                    <span className="collapse-header">
                      <PlusOutlined /> Additional Back-ups
                    </span>
                  ),
                  children: <p>{text}</p>,
                },
              ]}
            />
          </Space>
        </div>

        <div className="form-group">
          <div className="label">Security Questions</div>
          <Space className="space" direction="vertical">
            <Collapse
              collapsible="header"
              expandIconPosition="right"
              items={[
                {
                  key: "1",
                  label: (
                    <span className="collapse-header">Security Question 1</span>
                  ),
                  children: <p>{text}</p>,
                },
              ]}
            />
            <Collapse
              collapsible="header"
              expandIconPosition="right"
              items={[
                {
                  key: "2",
                  label: (
                    <span className="collapse-header">Security Question 2</span>
                  ),
                  children: <p>{text}</p>,
                },
              ]}
            />
            <Collapse
              collapsible="header"
              expandIconPosition="right"
              items={[
                {
                  key: "3",
                  label: (
                    <span className="collapse-header">
                      <PlusOutlined /> Additional Security Questions
                    </span>
                  ),
                  children: <p>{text}</p>,
                },
              ]}
            />
          </Space>
        </div>
      </Col>
    </div>
  );
};

export default AdvanceSecurity;
